import { Box } from "@mui/material";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { FullScreenDialog } from "@src/appV2/lib/Dialogs/FullScreen/Dialog";
import { Button } from "@src/appV2/redesign/components/Button";
import { PageFooterWrapper } from "@src/appV2/redesign/components/PageFooterWrapper";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { SwipeableViewsWithDots } from "@src/appV2/redesign/components/SwipeableViewsWithDots";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { type ReactNode, useCallback, useState } from "react";

interface UnfamiliarEducationDialogProps {
  modalState: UseModalState;
  analyticsEvent: string;
  onComplete: () => void;
  children: ReactNode[];
}

export function UnfamiliarEducationDialog(props: UnfamiliarEducationDialogProps) {
  const { modalState, analyticsEvent, onComplete, children } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  const isLastSlide = currentIndex === children.length - 1;

  useLogEffect(analyticsEvent);

  const handleComplete = useCallback(() => {
    onComplete();
    modalState.closeModal();
  }, [onComplete, modalState]);

  const handleChangeStep = useCallback((step: number) => {
    setCurrentIndex(step);
  }, []);

  return (
    <FullScreenDialog skipTopSafeAreaPadding modalState={modalState}>
      <PageWrapper
        variant="tertiary"
        sx={(theme) => ({
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
          background: `linear-gradient(to bottom, #e8f0f2 0%, #f5f3f1 30%, ${theme.palette.background.quaternary} 60%, ${theme.palette.background.quaternary} 100%)`,
        })}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SwipeableViewsWithDots
            activeStep={currentIndex}
            dotsPosition="bottom"
            dotsOffset="20%"
            onChangeStep={handleChangeStep}
          >
            {children}
          </SwipeableViewsWithDots>

          <PageFooterWrapper sx={{ visibility: isLastSlide ? "visible" : "hidden" }}>
            <Button fullWidth size="large" variant="contained" onClick={handleComplete}>
              Get started
            </Button>
          </PageFooterWrapper>
        </Box>
      </PageWrapper>
    </FullScreenDialog>
  );
}
